// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueGoogleCharts from "vue-google-charts";
import App from "./components/App.vue";
import router from "./routes";
import { attachValidation } from "@/shared/validation";
import { registerGtm } from "@/shared/pinia-gtm";
import { suppressRouterNavigationErrors } from "@/shared/routerHelper";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
Vue.component("vue-typeahead-bootstrap", VueTypeaheadBootstrap);
import { registerComponents } from "@bend-financial/styleguide";
registerComponents(Vue);

import "@bend-financial/styleguide/dist/styleguide.css";

import UniqueId from "vue-unique-id";
Vue.use(UniqueId);

attachValidation();

import VueCompositionAPI from "@vue/composition-api";
Vue.use(VueCompositionAPI);

import LinkPlugin from "@/shared/plugins/link/";
Vue.use(LinkPlugin);

import {
  createPinia,
  PiniaVuePlugin
} from "pinia";

Vue.use(PiniaVuePlugin);

import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import Router from "vue-router";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
pinia.use(({ store }) => {
  store.router = router;
});

Vue.prototype.$bendAppOptions = {
  validGroups: [ "admin", "employer", "Employer-Portal-User" ],
  site: "EMPLOYER"
};

suppressRouterNavigationErrors(Router);

Vue.use(Router);

Vue.config.productionTip = false;

Vue.use(VueGoogleCharts);

import oktaConfig from "@/okta-config";
import cognitoConfig from "@/cognito-config";
import { AuthFactory } from "@/shared/api/auth";
AuthFactory.init(cognitoConfig.employer, oktaConfig.employer);

registerGtm(router);

/* eslint-disable no-new */
// tslint:disable-next-line:no-unused-expression
new Vue({
  el: "#app",
  template: "<App/>",
  components: { App },
  router,
  pinia
});